/**
 * navBarUtils.js
 *
 * Чистые функции для NavBar — без React, без side effects.
 * Сюда выносим повторяющуюся логику «активен ли пункт» и «desktop или mobile menu».
 */

import { isDesktop } from "../../utilities/getDeviceType";
import { MIN_WIDTH_FOR_MENU } from "./navBarConstants";

/**
 * Desktop-sidebar или burger-menu?
 *
 * Desktop-sidebar показываем когда:
 * - ширина >= 1366px
 * - это не страница игры (/game/...) — там меню скрываем
 * - устройство считается desktop (не телефон)
 */
export const isDesktopMenuLayout = (pathname, screenWidth) => {
  const isGameRoute = pathname.startsWith("/game/");
  return screenWidth >= MIN_WIDTH_FOR_MENU && !isGameRoute && isDesktop();
};

/**
 * Подсвечиваем пункт меню как «текущая страница».
 *
 * Обычно достаточно pathname === path, но есть вложенные URL:
 * - /service/schedule/day → активен «Мое расписание»
 * - /service/students/123 → активен «Журнал учеников»
 * - /service/program/level/5 → активна «Программа»
 */
export const isMenuItemSelected = (pathname, path) =>
  pathname === path ||
  (pathname === "/service/schedule/day" && path === "/service/schedule") ||
  (pathname.includes("/service/students/") && path === "/service/journal") ||
  (pathname.includes("/service/program/level/") && path === "/service/program");
